import React from 'react';
import {connect} from "react-redux";
import {modals} from "../ducks";
import ModalRoot from "../components/ModalRoot";

const mapDispatchToProps = (dispatch) => ({
  showModal: (name, modalProps = {}) => dispatch(modals.actions.show(name, modalProps)),
});

/**
 * Higher order component that injects <ModalRoot/> and useful modal props.
 *
 * @example
 *   export default = withModals({MyModal: MyModal})(MyComponent);
 *
 * @param {undefined|Object} modals the modals that can be displayed
 * @returns {function(*): *}
 */
const withModals = (modals = undefined) => (Component) => {
  const modalRootProps = modals ? {modals} : {};

  const WrapperComponent = (props) => <React.Fragment>
    <Component {...props}/>
    <ModalRoot {...modalRootProps}/>
  </React.Fragment>;

  return connect(null, mapDispatchToProps)(WrapperComponent);
};

export default withModals;
